import { object, ref, string } from 'yup';
import { validateEmail } from './global';

export const securityValidation = (t, isName, isEmail, isPhone, isPassword, otpSent) =>
  object().shape({
    firstname: isName ? string()
      .required(t('common.FirstNameRequired'))
      .matches(
        /^[a-zA-Z\s]+$/,
        t('common.FirstNameInvalid') // Add a custom message for invalid input
      )
      .max(25, t('common.FirstNameTooLong')) : null, // Add translation key for max length
    email: isEmail ? string()
      .matches(validateEmail, t('common.invalidEmail'))
      .required(t('common.emailRequired')) : null,
    lastname: isName ? string()
      .required(t('common.LastNameRequired'))
      .matches(
        /^[a-zA-Z\s]+$/,
        t('common.LastNameInvalid') // Add a custom message for invalid input
      )
      .max(25, t('common.LastNameTooLong')) : null, // Add translation key for max length
    mobilenumber: isPhone
      ? string()
          .label('Phone number')
          .matches(/^(?!.*[\u0660-\u0669])[0-9]+$/, t('common.telephoneError1'))
          .matches(/^(05)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/, t('common.telephoneError2'))
          .min(10)
          .required(t('common.TelephoneRequired'))
      : null,
    otp: otpSent
      ? string()
          .length(4, t('common.OTPInvalidLength'))
          .matches(/^\d{4}$/, t('common.OTPInvalid'))
          .required(t('common.OTPRequired'))
      : null,
    currentPassword:
      isPassword || isName
        ? string().required(t('common.PasswordRequired'))
        : null,
    password: isPassword
      ? string()
          .min(8, t('common.HasAtLeast8Characters'))
          .matches(/[A-Z]/, t('common.ContainsOneUppercaseLetter'))
          .matches(/[a-z]/, t('common.ContainsOneLowercaseLetter'))
          .matches(/[0-9]/, t('common.ContainsOneNumber'))
          .required(t('common.PasswordRequired'))
      : null,
    confirmPassword: isPassword
      ? string()
          .oneOf([ref('password'), null], t('common.PasswordsMustMatch'))
          .required(t('common.ConfirmPasswordRequired'))
      : null,
  });

export const addressValidation = (t) =>
  object().shape({
    firstname: string()
      .required(t('common.FirstNameRequired'))
      .matches(
        /^[a-zA-Z\s]+$/,
        t('common.FirstNameInvalid') // Add a custom message for invalid input
      )
      .max(25, t('common.FirstNameTooLong')),
    lastname: string()
      .required(t('common.LastNameRequired'))
      .matches(
        /^[a-zA-Z\s]+$/,
        t('common.LastNameInvalid') // Add a custom message for invalid input
      )
      .max(25, t('common.LastNameTooLong')),
    phone: string()
      .label('Phone number')
      .matches(/^(?!.*[\u0660-\u0669])[0-9]+$/, t('common.telephoneError1'))
      .matches(/^(05)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/, t('common.telephoneError2'))
      .min(9)
      .required(t('common.TelephoneRequired')),

    city: string().required(t('common.CityRequired')),
    shortAddress: string().required(t('common.ShortAddressRequired')),
    address: string().min(10).required(t('common.AddressRequired')),
  });
export const rateProductValidation = (t) =>
  object().shape({
    message: string().required(t('common.RateMessageRequired')),
  });
